//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Hero from './components/Hero.vue'
import Tabs from './components/Tabs.vue'
import Title from './components/Title.vue'

import Tags from './components/Tags.vue'
import Result from './components/Result.vue'
export default {
  name: "SearchApp",
  components: {
    Hero,
    Tabs,
    Title,
    Tags,
    Result,
  },
  data() {
    return {
      railRemoved: false,
      headerRemoved:false
    }
  },
  computed:{
    gridClasses(){
      let classes = "";
      if(this.options.hideRail == true){
        classes = `search--norail`;
      }
      if(this.options.heroImage == 0 || this.options.heroImage == undefined){
        classes = `${classes} search--noheader`;
      }
      return classes;
    }
  }
};
